import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Signature from './Signature';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';

export default function CreatePost(){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip]);

    async function newKontrak(e){
        history("/create-kontrak",{state:{stuff:"new"}})
    }

    
    const nowstate = useSelector(state => state);

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }

                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }
            console.log("here")
            console.log(data)
            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
        if(post.reason === 'newKontrakStat'){
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
        }     
        
        if(post.reason === 'newDomisili'){
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderDomisilifromDB`,{
                id 
             }, {
                 responseType: "blob"
               }).then(resp => {
                         console.log(resp)
                             const blob = new Blob([resp.data], { type: 'application/pdf' })
                         // saveAs(blob);
                         var fileURLNew = URL.createObjectURL(blob);
                         console.log(fileURLNew)
                         setPreviewVisibility(true)
                         setLoadVisibility(false)
                         setFileURL(fileURLNew)
                     })
            }  

            if(post.reason === 'newKontrakStatTemp'){
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOTempDB`,{
                    id 
                 }, {
                     responseType: "blob"
                   }).then(resp => {
                             console.log(resp)
                                 const blob = new Blob([resp.data], { type: 'application/pdf' })
                             // saveAs(blob);
                             var fileURLNew = URL.createObjectURL(blob);
                             console.log(fileURLNew)
                             setPreviewVisibility(true)
                             setLoadVisibility(false)
                             setFileURL(fileURLNew)
                         })
                }  

                if(post.reason === 'newDomisiliKokasStat'){
                    let lastItem = post.domisiliKey[post.domisiliKey.length - 1];

                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${post.domisiliKey[lastItem]}`, {
                        responseType: 'blob' // Tell axios to get the response as a blob
                    })
                    .then((response) => {
                      const contentType = response.headers['content-type'];
                      console.log(response);
                      console.log(response.headers)
                      console.log(contentType)
                      if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
                        // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                        const blob = new Blob([response.data], { type: contentType });
                                var fileURLNew = URL.createObjectURL(blob);
            
                                setPreviewVisibility(true)
                                setFileURL(fileURLNew)   
                                setLoadVisibility(false)

            
                    } else {
                        // For other file types, download the file
                        const blob = new Blob([response.data], { type: contentType });
                        var fileURLNew = URL.createObjectURL(blob);
            
                        setPreviewVisibility(true)
                        setFileURL(fileURLNew) 
                        setLoadVisibility(false)
  
                    }
                    })
                    .catch((error) => {
                        console.log('Error fetching the file:', error);
                    });
                    }  
        
            

        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("KlienNama");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeOpenSignature = () => {
        setOpenSignature(false)
    }

    const sudahKirim = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateSent`, {
            reasonChange:currPreview.reason, id:currPreview._id
        }).then(() => {
            window.location.reload(); // refresh the page after successful update
        }).catch(error => {
            // handle error
            console.log(error);
        });
    }

    return <Grid container>
                <Dialog open={openSignature} onClose={closeOpenSignature}>
                    <Signature currPreview={currPreview} closeOpenSignature={closeOpenSignature}></Signature>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid xs={12} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <Grid container>
                        <Grid xs={5}>
                            <iframe src={`${fileURL}#zoom=60`} width="100%" height="500" style={{zoom:"150%"}}/>
                        </Grid>
                        <Grid xs={1}></Grid>
                        <Grid xs={5}>
                            <Typography variant="h4">Apakah kamu sudah kirimkan ini ke klien?</Typography>
                            <Grid sx={{mt:3}} xs={12}>
                                
                                <Button variant="contained" color="success" onClick={sudahKirim}>Sudah</Button>
                            </Grid>
                            <Grid sx={{mt:3}} xs={12}>
                            <Button variant="contained" color="error" onClick={handleClosePreview}>Tidak Jadi / Nanti Saja</Button>
                            </Grid>
                        </Grid>

                    </Grid>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>

                </Dialog>

                    <Grid>
                        
                           
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 250, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Klien
                                                </TableCell>
                                                <TableCell>
                                                    Company
                                                </TableCell>
                                                <TableCell>
                                                    Tipe
                                                </TableCell>
                                                <TableCell>
                                                    Tanggal
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{
            '&:hover': {
                backgroundColor: 'rgba(255, 83, 46,1) !important',
            },
            backgroundColor: 'red',
            height:"10px",
        }}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '1'}}>
                                                        <p>{post.KlienNama}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '1'}}>
                                                        <p>{post.CompanyName}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '1'}}>
                                                        { post.reason === 'newKontrakStat' && <p>Kontrak</p> }
                                                        { post.reason === 'newKontrakStatTemp' && <p>Kontrak Temp</p> }
                                                        { post.reason === 'newDomisiliKokasStat' && <p>Domisili Kokas</p> }
                                                        { post.reason === 'newDomisili' && <p>Domisili</p> }
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '1'}}>
                                                        { post.reason === 'newKontrakStat' && <p>{new Date(post.newKontrakStat).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p> }
                                                        { post.reason === 'newKontrakStatTemp' && <p>{new Date(post.newKontrakStatTemp).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p> }
                                                        { post.reason === 'newDomisiliKokasStat' && <p>{new Date(post.newDomisiliKokasStat).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p> }
                                                        { post.reason === 'newDomisili' && <p>{new Date(post.newDomisili).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p> }
                                                    </TableCell>
                                                    
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };